import type {
  PaymentMethod,
  StripeACHPayment,
  StripeCreditCardPayment,
  StripeSEPAPayment,
} from "@js/types/payments";

import { PaymentMethodVendorImage } from "../vendor-image";

import { StripeACH } from "./stripe-ach-payment";
import { StripeCreditCard } from "./stripe-credit-card";
import { StripeSEPAInline } from "./stripe-sepa-inline";

import styles from "./styles.module.scss";

type PaymentMethodInlineProps = {
  paymentMethod: PaymentMethod;
};

export const PaymentMethodInline = ({
  paymentMethod,
}: PaymentMethodInlineProps) => {
  switch (paymentMethod.content_type) {
    case ENUMS.PaymentContentType.StripeACHPaymentMethod:
      return <PaymentMethodACHInline paymentMethod={paymentMethod} />;

    case ENUMS.PaymentContentType.StripeCreditCardPaymentMethod:
      return <PaymentMethodCCInline paymentMethod={paymentMethod} />;

    case ENUMS.PaymentContentType.StripeSepaDirectDebitPaymentMethod:
      return <PaymentMethodSEPAInline paymentMethod={paymentMethod} />;

    default:
      paymentMethod satisfies never;
      return null;
  }
};

type PaymentMethodInlineBaseProps<TMethod extends PaymentMethod> = {
  paymentMethod: TMethod;
};

export const PaymentMethodCCInline = ({
  paymentMethod,
}: PaymentMethodInlineBaseProps<StripeCreditCardPayment>) => {
  return (
    <div className={styles.paymentMethodInline}>
      <PaymentMethodVendorImage
        paymentMethod={paymentMethod}
        className={styles.paymentMethodInlineVendorImage}
      />
      <StripeCreditCard paymentMethod={paymentMethod} />
      {paymentMethod.is_default && (
        <div className={styles.paymentMethodInlineDefaultIndicator}>
          DEFAULT
        </div>
      )}
    </div>
  );
};

export const PaymentMethodACHInline = ({
  paymentMethod,
}: PaymentMethodInlineBaseProps<StripeACHPayment>) => {
  return (
    <div className={styles.paymentMethodInline}>
      <PaymentMethodVendorImage
        paymentMethod={paymentMethod}
        className={styles.paymentMethodInlineVendorImage}
      />
      <StripeACH paymentMethod={paymentMethod} />
      {paymentMethod.is_default && (
        <div className={styles.paymentMethodInlineDefaultIndicator}>
          DEFAULT
        </div>
      )}
    </div>
  );
};

export const PaymentMethodSEPAInline = ({
  paymentMethod,
}: PaymentMethodInlineBaseProps<StripeSEPAPayment>) => {
  return (
    <div className={styles.paymentMethodInline}>
      <PaymentMethodVendorImage
        paymentMethod={paymentMethod}
        className={styles.paymentMethodInlineVendorImage}
      />
      <StripeSEPAInline paymentMethod={paymentMethod} />
      {paymentMethod.is_default && (
        <div className={styles.paymentMethodInlineDefaultIndicator}>
          DEFAULT
        </div>
      )}
    </div>
  );
};
